<script setup lang="ts">
import { computed, watch } from 'vue'
import { useDiscoveries } from '@/composables/useDiscoveries'
import { speciesById } from '@/lib/species'

const { justFound, dismissToast, found, total } = useDiscoveries()
const art = computed(() => (justFound.value ? speciesById(justFound.value) : undefined))

// Forsvinder af sig selv. Fundet er en lille glaede, ikke en besked der skal bekraeftes.
watch(justFound, (v) => {
  if (v) setTimeout(dismissToast, 4200)
})
</script>

<template>
  <transition name="fund">
    <div v-if="art" class="fund" role="status">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path v-for="(d, i) in art.paths" :key="i" :d="d" />
      </svg>
      <div>
        <strong>{{ $t('discovery.newSpecies') }}</strong>
        <p>{{ $t(`species.${art.id}.name`) }} · {{ $t('discovery.progress', { found, total }) }}</p>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.fund {
  position: fixed;
  left: 50%;
  bottom: calc(env(safe-area-inset-bottom, 0px) + 5.5rem);
  transform: translateX(-50%);
  z-index: 70;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  max-width: min(22rem, calc(100vw - 2rem));
  padding: 0.75rem 1.1rem;
  border: 1px solid color-mix(in srgb, var(--accent) 40%, transparent);
  border-radius: 999px;
  background: var(--surface-solid, var(--surface));
  box-shadow: var(--shadow);
}
.fund svg { width: 1.9rem; height: 1.9rem; flex: none; color: var(--accent); }
.fund strong { display: block; font-family: var(--font-display); font-size: 0.95rem; }
.fund p { margin: 0.1rem 0 0; color: var(--muted); font-size: 0.82rem; }

.fund-enter-active, .fund-leave-active { transition: opacity 0.35s, transform 0.35s; }
.fund-enter-from, .fund-leave-to { opacity: 0; transform: translate(-50%, 0.75rem); }
</style>
